module.exports = __webpack_public_path__ + "40c154a63c4f891f567a81b319cbc4a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/galeriaFotos/resplendor6.jpg
// module id = 74
// module chunks = 0